import * as React from 'react';
import { IExecutionStageSummary } from 'core/domain/IExecutionStage';

export interface IExecutionMarkerIconProps {
  stage: IExecutionStageSummary;
}

export class ExecutionMarkerIcon extends React.Component<IExecutionMarkerIconProps, any> {
  public render() {
    return this.props.stage.inSuspendedExecutionWindow ? (<span className="fa fa-clock-o"/>) : null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/core/ExecutionMarkerIcon.tsx